import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'kobetsu-shien-keikaku-misakusei-gensan',
    title: '個別支援計画未作成減算｜計画書があっても減算になる6つの落とし穴',
    description:
        '個別支援計画未作成減算は、計画書の有無だけで判定されるわけではありません。アセスメントの面接から担当者会議、文書同意、相談支援事業所への交付、モニタリングまで、一連の業務のどこが欠けると対象になるのか。減算率30%・50%の数え方と、いつからいつまで効くのかを条文の原文つきで整理しました。',
    excerpt:
        '計画書は全員分そろっている。それでも減算を指摘されることがあります。判定されているのは書類の有無ではなく、一連の業務が揃っているかどうかです。',
    category: '運営指導',
    keywords: [
        '個別支援計画未作成減算',
        '個別支援計画 減算',
        '計画未作成 30%',
        '未作成減算 いつから',
        '通所支援計画等未作成減算'
    ],
    publishedAt: '2026-05-07',
    updatedAt: '2026-09-15',
};
